import { useState } from "react";
import { Check, Copy, Code2 } from "lucide-react";

/** Collapse/expand panel that exposes an iframe embed snippet pointing at our public widget. */
export function EmbedCodeBlock({
  src,
  title = "Embed This Live Widget on Your Website / Blog",
  width = 320,
  height = 180,
}: {
  src: string;
  title?: string;
  width?: number;
  height?: number;
}) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const snippet = `<iframe src="${src}" width="${width}" height="${height}" style="border:0;border-radius:12px;max-width:100%" loading="lazy" title="Live Gold Rate by DrHint"></iframe>`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(snippet);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      /* noop */
    }
  }

  return (
    <section
      className="mt-8 rounded-2xl border border-border bg-card/40 overflow-hidden"
      aria-label="Embed widget snippet"
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left hover:bg-card/60"
      >
        <span className="flex items-center gap-2 text-sm font-bold">
          <Code2 className="h-4 w-4 text-gold" /> {title}
        </span>
        <span className="text-xs text-muted-foreground">{open ? "Hide" : "Show code"}</span>
      </button>
      {open && (
        <div className="px-5 pb-5 space-y-3">
          <p className="text-xs text-muted-foreground">
            Copy the snippet below into any blog post, news article or HTML page. Auto-updates every 10 minutes. Zero
            branding required — a small "Powered by drhint" line stays inside the widget.
          </p>
          <div className="relative">
            <pre className="overflow-x-auto rounded-lg border border-border p-3 pr-20 text-[11px] leading-relaxed" style={{ background: "#0b0d18", color: "#e9ecf5" }}>
              <code className="font-mono whitespace-pre-wrap break-all" style={{ color: "#e9ecf5" }}>{snippet}</code>
            </pre>
            <button
              type="button"
              onClick={copy}
              className="absolute top-2 right-2 inline-flex items-center gap-1 rounded-md bg-amber-500 px-2.5 py-1 text-[11px] font-bold hover:opacity-90" style={{ color: "#12131f" }}
            >
              {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
              {copied ? "Copied" : "Copy"}
            </button>
          </div>
          <div className="rounded-lg border border-border bg-card/60 p-3" style={{ aspectRatio: `${width} / ${height}`, maxWidth: width }}>
            <iframe
              src={src}
              width={width}
              height={height}
              style={{ border: 0, width: "100%", height: "100%", borderRadius: 8 }}
              loading="lazy"
              title="Live Gold Rate by DrHint preview"
            />
          </div>
        </div>
      )}
    </section>
  );
}